<template>
  <div class="container-cardlist">
    <!-- 좌우컨트롤러
      <div class="cardlist-controls">
        <button
          class="button-icon button-dim button-icon-small button-rounded"
          @click="scrollLeft"
          aria-label="Prev"
        >
          <IconChevronLeft />
        </button>
        <button
          class="button-icon button-dim button-icon-small button-rounded"
          @click="scrollRight"
          aria-label="Next"
        >
          <IconChevronRight />
        </button>
      </div>
    -->

    <div class="wrapper-cardlist" ref="scroller">
      <div class="wrapper-title">
        <h3 class="tit-h1 mb-3">{{ t('my_best_suited_interpretation') }}</h3>
        <p class="dim">{{ t('various_business_situation') }}</p>
      </div>
      <DashboardProductCard v-for="(card, i) in cards" :key="`card_${i}`" :card="card" />
    </div>

    <DashboardPromotionCard
      v-if="userType === 'HOST'"
      :title="t('start_now_hour_free')"
      :subtitle="t('seminar_conference_etc')"
      videoSrc="/videos/800x400_dashboard_hero.mp4"
      :buttonText="t('ss_explore_subscription')"
      @submit="moveToOnboardingPage"
    />

    <DashboardGuide />
    <!-- 스콘챗 기능소개 -->
    <!-- <DashboardFunction></DashboardFunction> -->
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import { useGtag } from '@/composables/shared/useGtag';
import { useUserStore } from '@/stores/user';

import DashboardGuide from './DashboardGuide.vue';
import DashboardProductCard from './DashboardProductCard.vue';
import DashboardPromotionCard from './DashboardPromotionCard.vue';
// import IconChevronLeft from '@/components/icons/IconChevronLeft.vue';
// import IconChevronRight from '@/components/icons/IconChevronRight.vue';

const { t } = useI18n();
const router = useRouter();

const userStore = useUserStore();

const { trackEventClick } = useGtag();

const userType = computed(() => {
  const { userType = '' } = userStore.userInfo || {};
  return userType;
});

const scroller = ref<HTMLElement | null>(null);
const scrollRight = () => scroller.value?.scrollBy({ left: 32, behavior: 'smooth' });
const scrollLeft = () => scroller.value?.scrollBy({ left: -32, behavior: 'smooth' });

const cards = [
  {
    title: 'label_conference',
    subtitle: 'label_conference_description',
    artBackground: '/images/dashboard/conference-card.png',
    videoSrc: ' ',
    buttonLabel: 'Conference',
    iconName: 'IconUserVoice',
    routeName: 'ss-chat-conference',
    delay: 1,
  },
  {
    title: 'label_meeting',
    subtitle: 'label_meeting_description',
    artBackground: '/images/dashboard/meeting-card.png',
    videoSrc: ' ',
    buttonLabel: 'Meeting',
    iconName: 'IconCompanyManage',
    routeName: 'ss-chat-meeting',
    delay: 0.5,
  },
  {
    title: 'label_audience',
    subtitle: 'label_audience_description',
    artBackground: '/images/dashboard/audience-card.png',
    videoSrc: ' ',
    buttonLabel: 'Audience',
    iconName: 'IconSound',
    routeName: 'ss-chat-audience',
    delay: 1.5,
  },
  {
    title: 'label_general',
    subtitle: 'label_general_description',
    artBackground: '/images/dashboard/general-card.png',
    videoSrc: ' ',
    buttonLabel: 'Conversation',
    iconName: 'IconUsers',
    routeName: 'ss-chat-general',
    delay: 2,
  },
  {
    title: 'label_single',
    subtitle: 'label_single_description',
    artBackground: '/images/dashboard/single-card.png',
    videoSrc: ' ',
    buttonLabel: 'Single',
    iconName: 'IconUser',
    routeName: 'ss-chat-single',
    delay: 2.5,
  },
];

const moveToOnboardingPage = () => {
  trackEventClick('main', '구독알아보기 배너');
  router.push({ name: 'ss-plan-manage' });
};
</script>

<style scoped lang="scss">
.container-cardlist {
  --gap: 1.25rem;
  --visible: 3.5; /* 한 화면에 3.5장 */
}
.cardlist-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 0.5rem;

  @include respond-to(mobile-portrait) {
    flex-direction: column;
    gap: 1rem;
    justify-content: start;
    align-items: start;
  }
}

.cardlist-controls {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  flex: 0 0 auto;

  @include respond-to(mobile-portrait) {
    width: 100%;
    justify-content: flex-end;
  }
}

.wrapper-cardlist {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3열 */
  gap: 1.25rem;
  overflow: visible !important; /* 스크롤 제거 */
  scroll-snap-type: none; /* 스크롤 스냅 해제 */
  .wrapper-title {
    padding: 2.5rem 0 0 1.5rem;
    max-width: 90%;
  }
  .dashbord-card {
    height: 280px;
    position: relative;
    border-radius: 1.25rem;
    overflow: hidden;
    cursor: pointer;
    :deep(.card-art) {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
    }
    :deep(.card-body) {
      position: relative;
      z-index: 1;
      padding: 1.5rem 2.5rem;
      max-width: 85%;
      word-break: keep-all;
      overflow-wrap: anywhere;
    }

    @include respond-to(tablet) {
      :deep(.card-body) {
        max-width: 100%;
        padding: 1.25rem 1.5rem;
        .card-title {
          font-size: $font-size-h6;
        }
        p {
          font-size: $font-size-psmall;
        }
      }
    }
  }
  @include respond-to(tablet) {
    .wrapper-title {
      max-width: 100%;
    }
  }
  @include respond-to(mobile-landscape) {
    gap: $size-m;
  }
}

/* 카드 폭을 개별 계산하던 기존 규칙 제거 */
.wrapper-cardlist :deep(.product-card) {
  flex: unset !important;
  width: 100%;
}

/* Tablet: 2개 */
@media (max-width: 960px) {
  .wrapper-cardlist {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile: 1개 */
@media (max-width: 640px) {
  .wrapper-cardlist {
    grid-template-columns: repeat(1, 1fr);
    .wrapper-title {
      padding: 1rem 0;
      text-align: center;
    }
  }
}
</style>
